import { WithServiceId } from '@mews-commander/types';
import { Stack, Typography } from '@optimus-web/core';
import { OccupancyData } from '@mews-commander/data-access';
import { ReservationPersonCountPure } from '../../../../../../../../components/reservation/ReservationPersonCount';
import { useServiceAgeCategories } from './useServiceAgeCategories';

interface CompanionCountsProps extends WithServiceId {
    occupancyData: Array<OccupancyData>;
}

export const CompanionCounts = ({ serviceId, occupancyData }: CompanionCountsProps) => {
    const { ageCategories } = useServiceAgeCategories({ serviceId });

    if (!ageCategories) return null;

    return (
        <Typography textStyle="bodyMedium" as="div">
            <Stack vertical>
                <ReservationPersonCountPure occupancyData={occupancyData} ageCategories={ageCategories} />
            </Stack>
        </Typography>
    );
};
